import React, { useState } from 'react';
import SectionCard from '../components/SectionCard';
import PillBadge from '../components/PillBadge';

const TIMELINE_LABELS = ['Nov', 'Déc', 'Jan', 'Fév', 'Mar', 'Avr'];

function formatNote(note) {
  if (note == null) return '—';
  const n = Number(note);
  if (Number.isNaN(n)) return '—';
  return n.toFixed(1).replace('.', ',');
}

function deltaLabel(progression_note) {
  if (progression_note == null) return null;
  const n = Number(progression_note);
  if (Number.isNaN(n) || n === 0) return null;
  const sign = n > 0 ? '↑ +' : '↓ ';
  return `${sign}${Math.abs(n).toFixed(1).replace('.', ',')} depuis nov`;
}

export default function EvolutionNoteSection({ restaurant }) {
  const [range, setRange] = useState('6m');
  const note = restaurant?.note_actuelle ?? restaurant?.note_depart ?? null;
  const delta = deltaLabel(restaurant?.progression_note);

  return (
    <SectionCard
      title="Évolution note Google"
      action={
        <div style={styles.toggle} role="tablist" aria-label="Période">
          <button
            type="button"
            role="tab"
            aria-selected={range === '6m'}
            onClick={() => setRange('6m')}
            style={{ ...styles.togglePill, ...(range === '6m' ? styles.toggleActive : null) }}
          >
            6 mois
          </button>
          <button
            type="button"
            role="tab"
            aria-selected={range === '1y'}
            onClick={() => setRange('1y')}
            style={{ ...styles.togglePill, ...(range === '1y' ? styles.toggleActive : null) }}
          >
            1 an
          </button>
        </div>
      }
    >
      <div style={styles.headerRow}>
        <div>
          <div style={styles.bigNote}>{formatNote(note)}</div>
          <div style={styles.bigNoteLabel}>note actuelle</div>
        </div>
        {delta && <PillBadge label={delta} variant="success" />}
      </div>

      <div style={styles.placeholder}>
        <div style={styles.placeholderIcon} aria-hidden>📈</div>
        <div style={styles.placeholderText}>
          Le graphe d'évolution apparaîtra après 30 jours d'utilisation
        </div>
      </div>

      <div style={styles.timeline} aria-hidden>
        {TIMELINE_LABELS.map((m) => (
          <span key={m} style={styles.timelineLabel}>{m}</span>
        ))}
      </div>
    </SectionCard>
  );
}

const styles = {
  toggle: {
    display: 'inline-flex',
    background: '#EDEAE3',
    borderRadius: 999,
    padding: 3,
  },
  togglePill: {
    border: 'none',
    background: 'transparent',
    color: '#6B6B6B',
    fontSize: 12,
    fontWeight: 600,
    padding: '5px 12px',
    borderRadius: 999,
    cursor: 'pointer',
    fontFamily: 'inherit',
  },
  toggleActive: {
    background: '#FFFFFF',
    color: '#1A1A1A',
    boxShadow: '0 1px 2px rgba(0,0,0,0.06)',
  },
  headerRow: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: 12,
  },
  bigNote: {
    fontSize: 32,
    fontWeight: 700,
    color: '#1A1A1A',
    letterSpacing: '-0.02em',
    lineHeight: 1.1,
  },
  bigNoteLabel: {
    fontSize: 13,
    color: '#6B6B6B',
  },
  placeholder: {
    background: '#FFF5F0',
    borderRadius: 12,
    padding: 16,
    display: 'flex',
    alignItems: 'center',
    gap: 12,
  },
  placeholderIcon: {
    fontSize: 22,
    lineHeight: 1,
  },
  placeholderText: {
    fontSize: 13,
    color: '#1A1A1A',
    lineHeight: 1.4,
  },
  timeline: {
    display: 'flex',
    justifyContent: 'space-between',
    fontSize: 11,
    color: '#9A9A9A',
    fontWeight: 600,
    letterSpacing: 0.3,
    paddingTop: 4,
  },
  timelineLabel: {
    flex: 1,
    textAlign: 'center',
  },
};
